import { createFileRoute, useRouter } from "@tanstack/react-router";
import { devLoginGuard, devLoginAs } from "@/lib/server-fns/auth";
import { Box, Container, Heading, Text, VStack, HStack, Card, Badge } from "@chakra-ui/react";
import { UserAvatar } from "@/components/user-avatar";

const DEV_USERS = [
  { userId: "dev-alice-001", email: "alice@example.com", name: "Alice Smith" },
  { userId: "dev-bob-002", email: "bob@example.com", name: "Bob Johnson" },
  { userId: "dev-carol-003", email: "carol@example.com", name: "Carol Davis" },
] as const;

export const Route = createFileRoute("/dev/login")({
  beforeLoad: () => devLoginGuard(),
  component: DevLogin,
});

function DevLogin() {
  const router = useRouter();

  const handleLogin = async (user: (typeof DEV_USERS)[number]) => {
    await devLoginAs({
      data: { userId: user.userId, email: user.email, name: user.name },
    });
    router.navigate({ to: "/dashboard" });
  };

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
      <Container maxW="sm" px={{ base: "4", md: "0" }}>
        <VStack gap={{ base: "4", md: "6" }}>
          <VStack gap="2">
            <Heading as="h1" size="xl">
              Dev Login
            </Heading>
            <Badge colorPalette="orange" variant="surface">
              Development Only
            </Badge>
            <Text color="fg.muted" textAlign="center" fontSize="sm">
              Select a user to sign in as. This bypasses Google OAuth.
            </Text>
          </VStack>

          <VStack gap="3" w="full">
            {DEV_USERS.map((user) => (
              <Card.Root
                key={user.userId}
                variant="outline"
                w="full"
                cursor="pointer"
                _hover={{ borderColor: "loonie.solid", bg: "bg.subtle" }}
                _active={{ bg: "bg.subtle" }}
                onClick={() => handleLogin(user)}
              >
                <Card.Body p="4">
                  <HStack gap="3">
                    <UserAvatar name={user.name} identifier={user.email} size="sm" />
                    <VStack align="start" gap="0">
                      <Text fontWeight="medium" fontSize="sm">
                        {user.name}
                      </Text>
                      <Text color="fg.muted" fontSize="xs">
                        {user.email}
                      </Text>
                    </VStack>
                  </HStack>
                </Card.Body>
              </Card.Root>
            ))}
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
}
